//分账配置

const SplitPaymentConfiguration = () => import(/*webpackChunkName:'split-accounting'*/'@/page/split-accounting/split-payment-configuration/split-payment-configuration.vue')
const WithdrawalUserConfig=()=>import(/*webpackChunkName:'split-accounting'*/'@/page/split-accounting/withdraw-user-config/withdraw-user-config.vue')
const WithdrawalConfig=()=>import(/*webpackChunkName:'split-accounting'*/'@/page/split-accounting/withdraw-config/withdraw-config.vue')

const RouteTemp = () => import(/*webpackChunkName:'split-accounting'*/'@/page/commons/routeTemp.vue')
export const splitPaymentConfiguration ={
    path: '/main/split-accounting/configuration',
    name: '分账配置',
    component: RouteTemp,
    meta: {
        requireAuth: true,
    },
    children: [{
        path: '/main/split-accounting/config/split',
    
        name: '分账配置',
        component: SplitPaymentConfiguration,
        meta: {
            requireAuth: true,
        },
    },
    {
        path: '/main/split-accounting/config/withdrawal',
        name: '提现配置',
        component: WithdrawalConfig,
        meta: {
            requireAuth: true,
        },
    },
    {
        path: '/main/split-accounting/config/withdrawal-user',
        name: '提现用户',
        component: WithdrawalUserConfig,
        meta: {
            requireAuth: true,
        },
    },
]
}